


































import { Component, Vue } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';

import { Order } from '@/models/order';
import { DepositModel } from '@/models/deposit';
import { Product } from '@/models/product';
import { FileType } from '@/models/file-type';
import { OrderComplainModel } from '@/models/order-complain';

import orderService from '@/services/order-service';
import depositService from '@/services/deposit-services';
import payauthorityServices from '@/services/payauthority-services';
import commonService from '@/services/common-services';

import { APP_CONFIG } from '@/config/app-config';

import ListProduct from './components/ListProduct.vue';
import DetailComplain from './components/DetailComplain.vue';
import ChatBox from '@/shared/components/ChatBox.vue';


const numeral = require('numeral');
@Component({
    components: {
        ListProduct,
        DetailComplain,
        Loading,
        'chat-box': ChatBox
    }
})
export default class ComplainOrder extends Vue {
    private order: Order | DepositModel = new Order();
    private complain: OrderComplainModel = new OrderComplainModel();

    private complainOptionValue = {
        indemnity: '',
        content: '',
        complainSelected: [],
        images: [] as FileType[],
        files: [] as FileType[],
        products: [] as Product[]
    };

    private isLoading = false;
    
    get orderId() {
        return this.$route.params.orderId;
    }

    get orderType() {
        if (this.compainId) {
            return this.complain.orderType;
        }
        return this.$route.params.orderType ? Number(this.$route.params.orderType) : 1;
    }

    get compainId() {
        return this.$route.params.complainId || 0;
    }

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get showProds() {
        return this.orderType === APP_CONFIG.ORDER_TYPE.order;
    }

    get showReason() {
        return this.orderType !== APP_CONFIG.ORDER_TYPE.payAuthority;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get rate() {
      return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
    }

    private async created() {
        this.order.products = [] as Product[];
        this.order.changedHistories = [];
        this.order.paymentHistory = [];
        this.order.orderComplains = [];

        if(!this.orderId) {
            return this.$router.push({ name: 'order-index' });
        }
        await this.getDataComplain();
        await this.loadData();
    }

    private async loadData() {
        const orderType = this.orderType;
        let result;
        this.order = new Order();
        this.order.id = Number(this.orderId);
        if (orderType  == APP_CONFIG.ORDER_TYPE.deposit) {
            result = await depositService.getDepositByID(this.orderId);
        } else if (orderType  == APP_CONFIG.ORDER_TYPE.order) {
            result = await orderService.orderById(this.orderId);
        } else if (orderType  == APP_CONFIG.ORDER_TYPE.payAuthority) {
            result = await payauthorityServices.getDetail(this.orderId);
        }
        
        if (result && result.data && result.data.status === 200) {
            const item = result.data.data;
            this.order.status = item.Status;
            if(orderType  == APP_CONFIG.ORDER_TYPE.payAuthority) {
                this.order.exchangeRate = item.ExchangeRate;
            }
            else { 
                this.order.amountCNY = orderType  == APP_CONFIG.ORDER_TYPE.deposit ? Math.round(item.TotalPriceVND * 100 / item.CurentCNYVN) / 100 : item.AmountCNY;
                this.order.amountVND = orderType  == APP_CONFIG.ORDER_TYPE.deposit ? item.TotalPriceVND : item.AmountVND;
                this.order.exchangeRate = orderType  == APP_CONFIG.ORDER_TYPE.deposit ? item.CurentCNYVN : item.ExchangeRate;
                this.order.totalAmountVND = orderType  == APP_CONFIG.ORDER_TYPE.deposit ? item.TotalPriceVND : item.TotalAmountVND;
                this.order.totalRealAmount = orderType  == APP_CONFIG.ORDER_TYPE.deposit ? item.TotalPriceVND :item.TotalRealAmount;
                this.order.totalRealAmountCNY = orderType  == APP_CONFIG.ORDER_TYPE.deposit ? Math.round(item.TotalPriceVND * 100 / item.CurentCNYVN) / 100 : item.TotalRealAmountCNY;
            }            
            this.order.products = [] as Product[]
            if (orderType === APP_CONFIG.ORDER_TYPE.order) {
                for (const prod of item.Products) {
                    const product = new Product();
                    product.id = prod.ID;
                    product.imageOrigin = prod.image_origin;
                    product.linkOrigin = prod.link_origin;
                    product.priceOrigin = prod.price_origin;
                    product.pricePromotion = prod.price_promotion;
                    product.priceOriginVND = prod.price_origin * item.ExchangeRate;
                    product.pricePromotionVND = prod.price_promotion * item.ExchangeRate;
                    product.amountCN = (prod.price_promotion || prod.price_origin) * prod.quantity; 
                    product.property = prod.property;
                    product.quantity = prod.quantity;
                    product.titleOrigin = prod.title_origin;
                    product.isChoose = this.complain.productIds.filter(x => x === prod.ID).length > 0 ? true : false;
                    this.order.products.push(product);
                    if(product.isChoose) {
                        this.complainOptionValue.products.push(product)
                    }
                }
            }
        }
    }

    private async getDataComplain() {
        this.complain.id = numeral(this.compainId).value();
        if (this.complain.id > 0) {
            const result = await orderService.getComplainById(this.complain.id);
            if (result && result.status === 200 && result.data.status === 200) {
                this.mapComplain(result.data.data);
            }
        }
    }
   
    private onSubDataInDetail(data: any) {
        this.complainOptionValue = {
            ...this.complainOptionValue,
            indemnity: data.indemnity,
            content: data.content,
            complainSelected: data.complainSelected,
            images: data.images,
            files: data.files,
        };
    }

    private onSubDataInListProduct(data: any) {
        this.complainOptionValue = {
            ...this.complainOptionValue,
            products: data.products
        };
    }

    private async onCancelComplainOrder() {
        this.isLoading = true;
        const dataRequest: any = {
            Status: 0,
            ProductIds: this.complainOptionValue.products.map((prod: any) => prod.id)
        };
        if (this.orderType != APP_CONFIG.ORDER_TYPE.order) {
            dataRequest.ProductIds = [];
            dataRequest.OrderType = this.orderType;
            dataRequest.OrderID = this.orderId;
        }
        await orderService.updateComplainOrder(this.complain.id, dataRequest);
        Vue.notify({
            group: 'foo',
            type: 'success',
            title: 'Thông báo!',
            text: 'Hủy khiếu nại thành công!',
        });
        this.isLoading = false;
        if (this.orderType == APP_CONFIG.ORDER_TYPE.deposit) {
            this.$router.push({ name: 'deposit-detail', params: { id: this.orderId.toString() } }).catch(() => {
                return false;
            });
        } else if (this.orderType == APP_CONFIG.ORDER_TYPE.order) {
            this.$router.push({ name: 'order-detail', params: { orderId: this.orderId.toString() } }).catch(() => {
                return false;
            });
        } else {
            this.$router.push({ name: 'payauthority-detail', params: { id: this.orderId.toString() } }).catch(() => {
                return false;
            });
        }
    }

    private async onComplainOrder() {
        if(this.complainOptionValue.products.length === 0 && this.orderType === APP_CONFIG.ORDER_TYPE.order) {
             Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Vui lòng chọn sản phẩm khiếu nại!'
            });
        } else {
            this.isLoading = true;
            await this.onUploadImage();
            await this.onUploadFiles();
            const result = await this.onAddComplainOrder();
            if (result && result.status === 200 && result.data.status === 200 && this.order.status !== 13) {
                await this.onChangeStatusOrder();
                if(!this.orderId) {
                    await this.getDataComplain();
                    await this.loadData();
                }       
            }
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Tạo khiếu nại thành công!',
            });
            this.isLoading = false;
            if (this.complain.id === 0) {
                if (this.orderType == APP_CONFIG.ORDER_TYPE.deposit) {
                    this.$router.push({ name: 'deposit-detail', params: { id: this.orderId.toString() } }).catch(() => {
                        return false;
                    });
                } else if (this.orderType == APP_CONFIG.ORDER_TYPE.order) {
                    this.$router.push({ name: 'order-detail', params: { orderId: this.orderId.toString() } }).catch(() => {
                        return false;
                    });
                }
                else {
                    this.$router.push({ name: 'payauthority-detail', params: { id: this.orderId.toString() } }).catch(() => {
                        return false;
                    });
                }
            }
        }
    }

    private async mapComplain(data: any) {
        this.complain = {
            ...this.complain,
            amount: data.Amount,
            amountNDT: data.AmountNDT,
            complainText: data.ComplainText,
            createBy: data.CreatedBy,
            createDate: data.CreatedDate,
            exchangeRate: data.ExchangeRate,
            id: data.ID,
            img: data.IMG,
            files: data.Files,
            isBroken: data.IsBroken === 1,
            isMissGood: data.IsMissGood === 1,
            isOption: data.IsOption === 1,
            isOther: data.IsOther === 1,
            modifiedBy: data.ModifiedBy,
            modifiedDate: data.ModifiedDate,
            noteForUser: data.NoteForUser,
            noteOfStaff: data.NoteOfStaff,
            orderId: data.OrderID,
            orderType: data.OrderType,
            productIds: data.ProductIds,
            receivedId: data.ReceivedID,
            status: data.Status,
            uId: data.UID,
            userName: data.Username
        };
    }

    private async onUploadImage() {
        for(const image of this.complainOptionValue.images) {
            if(image.file === undefined) {
                continue;
            }
            // const formData = new FormData();
            // formData.append('imagefile', image.file as any);
            // formData.append('filename', image.fileName);
            const result = await commonService.uploadFile(image.file, image.fileName);
        }
    } 
    
    private async onUploadFiles() {
        for(const image of this.complainOptionValue.files) {
            if(image.file === undefined) {
                continue;
            }
            const result = await commonService.uploadFile(image.file, image.fileName);
        }
    }

    private async onAddComplainOrder() {
        const amountNDT = numeral(this.complainOptionValue.indemnity.split(',').join('')).value();
        let orderType = this.orderType;
        const dataRequest = {
            UID: this.userInfo.userId,
            Username: this.userInfo.userName,
            OrderID: this.order.id,
            OrderType: orderType,
            ExchangeRate: this.order.exchangeRate,
            Amount: amountNDT * this.order.exchangeRate,
            IMG: this.complainOptionValue.images.reduce((imgs: string, image: any) => {
                const fileName = image.fileName ? image.fileName : (image.src ? image.src.replace(/^.*[\\\/]/, '') : '');
                return imgs + (imgs === '' ? fileName : (';' + fileName))
            }, ''),
            Files: this.complainOptionValue.files.reduce((imgs: string, image: any) => {
                const fileName = image.fileName ? image.fileName : (image.src ? image.src.replace(/^.*[\\\/]/, '') : '');
                return imgs + (imgs === '' ? fileName : (';' + fileName))
            }, ''),
            ComplainText: this.complainOptionValue.content,
            Status: 1,
            IsMissGood: this.complainOptionValue.complainSelected.find((x: any) => x.value === 1) ? 1 : 0,
            IsBroken: this.complainOptionValue.complainSelected.find((x: any) => x.value === 2) ? 1 : 0,
            IsOption: this.complainOptionValue.complainSelected.find((x: any) => x.value === 3) ? 1 : 0,
            IsOther: this.complainOptionValue.complainSelected.find((x: any) => x.value === 4) ? 1 : 0,
            ReceivedID: 1,
            AmountNDT: amountNDT,
            NoteOfStaff: null,
            NoteForUser: null,
            ProductIds: orderType != APP_CONFIG.ORDER_TYPE.order ? [] : this.complainOptionValue.products.map((prod: any) => prod.id)
        };
        if(this.complain.id === 0) {
            return await orderService.complainOrder(dataRequest);
        } else {
            return await orderService.updateComplainOrder(this.complain.id, dataRequest);
        }
    }

    private async onChangeStatusOrder() {
        let result;
        if (this.orderType == APP_CONFIG.ORDER_TYPE.deposit) {
            result = await depositService.updateDeposit(this.order.id, { Status: 13 });
        } else if (this.orderType == APP_CONFIG.ORDER_TYPE.order) {
            result = await orderService.updateOrder(this.order.id, { Status: 13 });
        }
        else {
            result = await payauthorityServices.updateDetail(this.order.id, { Status: 4 });
        }
        
        if (result && result.status === 200 && result.data.status === 200) {
            this.order = {
                ...this.order,
                status: this.orderType == APP_CONFIG.ORDER_TYPE.payAuthority ? 4 : 13
            };
        }
    }
}
